/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import React from "react";
import { useHistory } from "react-router-dom";
import Auth0Provider, { AppState } from "./auth0-provider";

type Props = Omit<
  React.ComponentProps<typeof Auth0Provider>,
  "onRedirectCallback"
>;

export function Auth0ProviderWithHistory(props: Props) {
  const history = useHistory();

  const onRedirectCallback = (appState: AppState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return <Auth0Provider onRedirectCallback={onRedirectCallback} {...props} />;
}
